// ** React Imports
import { useState } from "react";
import { useNavigate } from "react-router-dom";

// ** MUI Imports
import {
  Button,
  Box,
  Typography,
  FormControlLabel,
  Divider,
  Checkbox,
  Popover,
} from "@mui/material";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { SaveConvert } from "../logic/ConvertToLogic";
import ScheduleAssessment from './ScheduleAssessment';
import { useTheme } from "@mui/material/styles";

const dropdownItemsStyle = {
  px: 6, 
  py: 2, 
  '&:hover': { 
    backgroundColor: 'action.hover', cursor: 'pointer' 
  }
}

const ConversionComponent = ({
  handleOpenSchedule,
  schedulingReq,
  setSchedulingReq,
  originalRequestID,
  openScheduleAst,
  handleCloseScheduleAstDlg,
  setLoading,
  module,
  rules,
  hasConvertToPermission
}) => {
// const ConversionComponent = ({

const MySwal = withReactContent(Swal);
const theme = useTheme();
  

// }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  // const [openScheduleAst, setOpenScheduleAst] = useState(false); // Track the dialog state for ScheduleAssessment
  const [convertedRequestID, setConvertedRequestID] = useState(null); // Track the new requestID after
  const navigate = useNavigate();
  const handleClick = (event) => {
    // if (schedulingReq) {
      setAnchorEl(event.currentTarget);
    // }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleConvert = async (convertType) => {
    if(!hasConvertToPermission) return;

    const conversionObj = {
      originalRequestID,
      convertToEntityType: convertType, // Pass the selected conversion type
    };

    // 
    const result = await MySwal.fire({
      title: '<strong>Are you sure?</strong>',
      html: `<span>Are you sure you want to convert to ${convertType === "WorkOrder" ? "Work Order" : convertType} ?</span>`,
      showCancelButton: true,
      confirmButtonText: 'Yes, convert!',
      cancelButtonText: 'No, go back',
       width: '390px', // Explicit width control
    padding: '1rem',
      focusConfirm: false,
       showCloseButton: true,
       closeButtonHtml: '&times;', // This is the × symbol
      customClass: {
        popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
          cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
      }
    });
  
        if (result.isConfirmed) {
          const response = await SaveConvert(conversionObj); // Call the SaveConvert function
          if (response && response.result) {
            // After conversion, update the requestID from the API response
            setConvertedRequestID(response.result.requestID);
      
            const navigationUrl =
            convertType === "Assessment"
              ? `/assessments/detail/${response.result.requestID}`
              : convertType === "Estimate"
              ? `/estimates/detail/${response.result.requestID}`
              : convertType === "WorkOrder"
              ? `/work-orders/detail/${response.result.requestID}`
              : "/";
            
            // Open the ScheduleAssessment dialog if scheduling is required
            if (schedulingReq && convertType === "Assessment") {
              handleOpenSchedule(); // Open the ScheduleAssessment dialog after conversion
            } else {
              handleClose(); // Close the Popover
              // console.log(navigationUrl)
              localStorage.setItem('fromConversion', 'true');
              navigate(navigationUrl)
            }
          }
          // const deleteResult = await DeleteJobsite(jobsiteID, customerID, navigate);
          
          // if (deleteResult && !deleteResult.isError) {
          //   fetchJobsites();
          //   toast.success(`"${jobsiteName}" Jobsite deleted successfully.`, {
          //     position: 'top-right',
          //     autoClose: 5000,
          //     hideProgressBar: false,
          //     closeOnClick: false,
          //     pauseOnHover: true,
          //     draggable: true,
          //     progress: undefined,
          //     theme: 'light',
          //   });
          // } else {
          //   toast.error(deleteResult.message || 'Failed to delete the jobsite.', {
          //     position: 'top-right',
          //     autoClose: 5000,
          //     hideProgressBar: false,
          //     closeOnClick: false,
          //     pauseOnHover: true,
          //     draggable: true,
          //     progress: undefined,
          //     theme: 'light',
          //   });
          // }
        }
    // 
    

    handleClose(); // Close the Popover
  };

  return (
    <div>
      <Button
        variant="contained"
        color="main"
        endIcon={<KeyboardArrowDownIcon />}
        aria-describedby={id}
        disabled={rules.isCompleted || !hasConvertToPermission}
        {...(hasConvertToPermission && {
          onClick: handleClick
        })}
      >
        Convert To
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {module === "Request" && (
          <Box sx={{ py: 2 }}>
            <Typography
              variant="h6"
              sx={dropdownItemsStyle}
              onClick={() => handleConvert('Assessment')}
            >
              Convert to Assessment
            </Typography>
            <FormControlLabel
              sx={{ px: 6 }}
              control={
                <Checkbox
                  color="success"
                  checked={schedulingReq}
                  onChange={() => setSchedulingReq(!schedulingReq)}
                />
              }
              label="Scheduling Required"
            />
            <Divider
              sx={{
                color: "text.disabled",
                my: 2,
              }}
            />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Typography variant="h6" sx={dropdownItemsStyle} onClick={() => handleConvert('Estimate')}>
                Convert to Estimate
              </Typography>
              <Typography variant="h6" sx={dropdownItemsStyle} onClick={() => handleConvert('WorkOrder')}>
                Convert to Work Order
              </Typography>
              {/* <Typography variant="h6" sx={dropdownItemsStyle} onClick={() => handleConvert('Invoice')}>
                Convert to Invoice
              </Typography> */}
            </Box>
          </Box>
        )}

        {module === "Assessment" && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              py: 2,
            }}
          >
            <Typography variant="h6" sx={dropdownItemsStyle} onClick={() => handleConvert('Estimate')}>
              Convert to Estimate
            </Typography>
            <Typography variant="h6" sx={dropdownItemsStyle} onClick={() => handleConvert('WorkOrder')}>
              Convert to Work Order
            </Typography>
          </Box>
        )}

        {module === "Estimate" && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              py: 2,
            }}
          >
            <Typography variant="h6" sx={dropdownItemsStyle} onClick={() => handleConvert('WorkOrder')}>
              Convert to Work Order
            </Typography>
            {/* <Typography variant="h6" sx={dropdownItemsStyle} onClick={() => handleConvert('Invoice')}>
              Convert to Invoice
            </Typography> */}
          </Box>
        )}
      </Popover>

      <ScheduleAssessment 
        open={openScheduleAst}
        handleClose={handleCloseScheduleAstDlg}
        entity='convert'
        requestID={convertedRequestID}
        // serviceRequest={serviceRequest}
        requestType={"Assessment"}
        setLoading={setLoading}
        setSchedulingReq={setSchedulingReq}
      />
    </div>
  );
};

export default ConversionComponent;